import { useAppContext } from '../../contexts/AppContext'

const Button = ({ label, onClick, icon, disabled }) => {
  const { accentColor } = useAppContext()
  return (
    <div
      style={{ background: accentColor, borderColor: accentColor }}
      className={`
        leading-8 min-w-80 max-sm:min-w-32 rounded-md items-center justify-center self-start flex gap-2 px-5 py-1 
        border-[1px] border-transparent fill-[#c2c2c2] text-[#c2c2c2]
       ${
         disabled
           ? 'text-[#bbb] dark:text-zinc-500 fill-[#bbb] dark:fill-zink-500 outline outline-1 outline-[#bbb] dark:outline-zinc-500 cursor-not-allowed'
           : `
            text-[#070707] dark:text-zinc-400 fill-[#070707] dark:fill-zinc-400 bg-wp-dark dark:bg-zinc-700 
              cursor-pointer dark:hover:bg-zinc-600 hover:text-white hover:fill-white
            `
       }`}
      onClick={onClick}
    >
      {icon}
      <span>{label}</span>
    </div>
  )
}

export default Button
